/**
 * Datetime utility functions for the SDK
 */

/**
 * Get the current datetime formatted for LLM prompts
 * This format helps the LLM understand time-related queries
 *
 * @returns Formatted datetime string (e.g., "Sunday, January 5, 2025, 10:30 AM EST")
 */
export function getCurrentDateTimeForPrompt(): string {
  return new Date().toLocaleString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZoneName: 'short'
  });
}

/**
 * Get current date in ISO format (YYYY-MM-DD)
 * Useful for SQL date comparisons
 *
 * @returns ISO date string (e.g., "2025-01-05")
 */
export function getCurrentDateISO(): string {
  return new Date().toISOString().split('T')[0];
}

/**
 * Get current datetime in ISO format
 *
 * @returns ISO datetime string (e.g., "2025-01-05T10:30:00.000Z")
 */
export function getCurrentDateTimeISO(): string {
  return new Date().toISOString();
}
